import SuperJSON from 'superjson';

const useSessionStorage = <T>(key: string) => {
  const saveData = (data: T) => {
    try {
      sessionStorage.setItem(key, SuperJSON.stringify(data));
    } catch {
      // ignore storage errors (e.g. private browsing quota)
    }
  };

  const getData = (): T | null => {
    try {
      const stored = sessionStorage.getItem(key);
      if (!stored) return null;
      return SuperJSON.parse<T>(stored);
    } catch {
      return null;
    }
  };

  const hasData = () => sessionStorage.getItem(key) !== null;

  const clear = () => sessionStorage.removeItem(key);

  return { saveData, getData, hasData, clear };
};

export default useSessionStorage;
